import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";

export const InvoiceTemplateBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedInvoiceTemplateCount = 0,
        onInvoiceTemplateBulkArchive,
        onInvoiceTemplateBulkUnarchive,
    } = options;

    const heading = `${pluralizeWithCount("template", selectedInvoiceTemplateCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onInvoiceTemplateBulkArchive && (
                <CommandItem
                    keywords={["archive"]}
                    onSelect={onInvoiceTemplateBulkArchive}
                >
                    Archive
                </CommandItem>
            )}
            {onInvoiceTemplateBulkUnarchive && (
                <CommandItem
                    keywords={["activate", "unarchive", "restore"]}
                    onSelect={onInvoiceTemplateBulkUnarchive}
                >
                    Unarchive
                </CommandItem>
            )}
        </Command.Group>
    );
};
